/**
 * description 融合编辑器-切换渠道弹窗
 * created by he.zhikai
 * created on 2017-12-29
 */

'use strict';
angular.module('editFusionSwitchNavsModule', [])
    .controller('editFusionSwitchNavsCtrl', ['$scope', '$q', '$state', '$controller', '$modalInstance', 'toNav', 'fromNavs',
        function($scope, $q, $state, $controller, $modalInstance, toNav, fromNavs) {
            initStatus();
            initData();

            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.data = {
                    fromNavs: fromNavs,
                    toNavs: toNav
                };
            }

            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {
                $scope.data.selectedFromNav = $scope.data.fromNavs[0];
            }

            /**
             * [cancel description] 取消
             * @return {[type]} [description]
             */
            $scope.cancel = function() {
                $modalInstance.dismiss();
            };

            /**
             * [notCopy description] 不复制
             * @return {[type]} [description]
             */
            $scope.notCopy = function() {
                $modalInstance.close();
            };

            /**
             * [copy description] 复制
             * @return {[type]} [description]
             */
            $scope.copy = function() {
                if ($scope.data.selectedFromNav.controller) {
                    $modalInstance.close($scope.data.selectedFromNav);
                } else {
                    contructController().then(function() {
                        $modalInstance.close($scope.data.selectedFromNav);
                    });
                }
            };

            /**
             * [contructController description] 构造控制器
             * @return {[type]} [description]
             */
            function contructController() {
                var deffer = $q.defer();
                var navInfo = $state.get($scope.data.selectedFromNav.routerName).views[''];
                var controller = {};
                controller.$element = $(document.createElement('div'));
                controller.$scope = $scope.$new();
                $controller(navInfo.controller, controller);
                $scope.fusionLoadingPromise = controller.$scope.initData().then(function() {
                    $scope.data.selectedFromNav.controller = controller;
                    $scope.data.selectedFromNav.list = angular.copy(controller.$scope.list);
                    $scope.data.selectedFromNav.data = angular.copy(controller.$scope.data);
                    $scope.data.selectedFromNav.status = angular.copy(controller.$scope.status);
                    deffer.resolve();
                });
                return deffer.promise;
            }
        }
    ]);
